import { Box, Button, TextField } from '@mui/material'
import { useContext, useState } from 'react'

import { Modal } from '../../../components/Modal/Modal'
import {
  ResourcesContext,
  ResourcesContextInterface,
  rootResourceFolder,
} from '../../../providers/Resources/Resources.provider'
import { ResourceFolder } from './Resources.view'

interface UpdateResourceFolderNameModalInterface {
  currentFolder: ResourceFolder | null
  editModalOpen: boolean
  setEditModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  editFolder: ResourceFolder | rootResourceFolder | null

  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  fetchFolderContent: (folderId: number) => Promise<void>
}

export const UpdateResourceFolderNameModal = ({
  currentFolder,
  editModalOpen,
  setEditModalOpen,
  editFolder,
  setLoading,
  fetchFolderContent,
}: UpdateResourceFolderNameModalInterface) => {
  const { updateResourceFolderName, getRootResourceFolders } = useContext(
    ResourcesContext
  ) as ResourcesContextInterface

  const [newFolderName, setNewFolderName] = useState('')

  return (
    <Modal
      title={'Update Folder Name'}
      open={editModalOpen}
      setOpen={setEditModalOpen}
      ModalContent={
        <Box sx={{ p: 2 }}>
          <TextField
            fullWidth
            label='Enter New Folder Name'
            variant='outlined'
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
          <Box
            sx={{
              mt: 3,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button onClick={() => setEditModalOpen(false)} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              onClick={async () => {
                setLoading(true)
                // Close modal and refresh folder content after creation
                setEditModalOpen(false)
                setNewFolderName('')

                editFolder &&
                  (await updateResourceFolderName(editFolder.id, newFolderName))

                if (currentFolder && currentFolder.id) {
                  fetchFolderContent(currentFolder.id)
                } else {
                  await getRootResourceFolders()
                  setLoading(false)
                }
              }}
              disabled={!newFolderName.trim()}
            >
              Update Folder Name
            </Button>
          </Box>
        </Box>
      }
    />
  )
}
